
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const steps = [
  { name: "Order Placed", description: "on Thu, 11 Jul", value: "PLACED" },
  { name: "Order Pending", description: "on Thu, 11 Jul", value: "PENDING" },
  {
    name: "Order Confirmed",
    description: "Item Packed in Dispatch Warehouse",
    value: "CONFIRMED",
  },
  { name: "Shipped", description: "by Mon, 15 Jul", value: "SHIPPED" },
 
];

const canceledStep = [
  { name: "Order Placed", description: "on Thu, 11 Jul", value: "PLACED" },
  { name: "Order Canceled", description: "on Thu, 11 Jul", value: "CANCELLED" },
];

interface OrderStepperProps {
  orderStatus: string;
}

 // Change this value based on the current step

export const OrderStepper: React.FC<OrderStepperProps> = ({ orderStatus }) => {
  const [statusStep, setStatusStep] = useState(steps);

  useEffect(() => {
    if (orderStatus === "CANCELLED") {
      setStatusStep(canceledStep);
    } else {
      setStatusStep(steps);
    }
  }, [orderStatus]);

  // Instead of setting currentStep manually, dynamically determine it based on the orderStatus.
  const currentStep = statusStep.findIndex(step=>step.value===orderStatus);

  return (
    <Box className="my-10">
      {statusStep.map((step, index) => {
        // Debugging message

        // Return JSX elements
        return (
          <div key={index} className="flex px-4">
            <div className="flex flex-col items-center">
              {/* circle dot  */}
              <Box
                sx={{ zIndex: -1 }}
                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  index <= currentStep
                    ? "bg-gray-200 text-teal-500"
                    : "bg-gray-300 text-gray-600"
                }`}
              >
                {step.value === orderStatus ? (
                  <CheckCircleIcon />
                ) : (
                  <FiberManualRecordIcon sx={{ zIndex: -1 }} />
                )}
              </Box>
              {/* line below the circle dot */}
              {/* index!=status.length => 4!=4:false => don't add line */}
              {index < statusStep.length - 1 && (
                <div
                  className={`border h-20 w-[2px] ${
                    index < currentStep ? "bg-primary" : "bg-gray-300 "
                  }`}
                ></div>
              )}
            </div>
            <div className="ml-2 w-full">
              <div
                className={`${
                  step.value === orderStatus
                    ? "bg-primary p-2 text-white font-medium rounded-md -translate-y-3"
                    : "text-gray-600"
                } ${
                  orderStatus === "CANCELLED" && step.value === orderStatus
                    ? "bg-red-500"
                    : ""
                } w-full`}
              >
                <p>{step.name}</p>
                <p
                  className={`${
                    step.value === orderStatus
                      ? "text-gray-200"
                      : "text-gray-400"
                  } text-xs`}
                >
                  {step.description}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </Box>
  );
};
